import { CameraFlipOutlineIcon } from './CameraFlipOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A40CFB47-3650-42BF-874C-C5BF09641708
 * name camera-flip-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-flip-outline.svg
 * tags
 * - Photography 
 */
export const CameraRefreshOutlineIcon = CameraFlipOutlineIcon;
export default CameraRefreshOutlineIcon